import { Container } from "components/layout/Container";
import { CardList } from "components/pages/samples/CardList";
import { Filters } from "components/pages/samples/Filters";
import { PremiumFeatures } from "components/pages/samples/PremiumFeatures";
import { SearchBlock } from "components/pages/samples/SearchBlock";
import styles from "./SectionSamples.module.scss";
import { SamplePageSampleCardProps } from "@/components/pages/samples/SamplePageSampleCard";

type SectionSamplesProps = {
  samplesList: (Omit<SamplePageSampleCardProps, "onClick"> & { id: string })[];
};

export const SectionSamples = ({ samplesList }: SectionSamplesProps) => (
  <>
    <Filters />
    <Container>
      <SearchBlock />
    </Container>
    <Container className={styles.wrapper}>
      <CardList samplesList={samplesList} />
      <PremiumFeatures className={styles.premiumFeatures} />
    </Container>
  </>
);
